import * as Yup from 'yup'
import {Brand, initialBrand} from '../core/_models'
import {createBrand, updateBrand} from '../core/_requests'
import {Formik, Field, Form} from 'formik'
import {useListView} from '@/components/table/core/ListViewProvider'
import {useQueryResponse} from '@/components/table/core/QueryResponseProvider'
import {InputText, FormActions, handleErrors } from '@/components/form'

const schema = Yup.object({
  name: Yup.string().min(3, 'Minimum 3 characters').required('Name is required'),
  slug: Yup.string().min(3, 'Minimum 3 characters').required('SLUG is required'),
  color: Yup.string().matches(/^#[A-Za-z0-9]{6}$/, 'Must be a valid color code').required('Color is required'),
  icon: Yup.string().min(3, 'Minimum 3 characters').required('Icon is required'),
})

const BrandForm = () => {
  const {itemForUpdate, setItemForUpdate, setAction} = useListView()

  const {refetch} = useQueryResponse()
  const brand = itemForUpdate as Brand
  const close = () => {
    setAction(undefined)
    setItemForUpdate(undefined)
  }

  return (
    <Formik
      initialValues={brand || initialBrand}
      validationSchema={schema}
      onSubmit={async (values, {setErrors}) => {
        try {
          if (!brand) {
            await createBrand(values)
          } else {
            await updateBrand(values)
          }
          close()
          refetch()
        } catch (e: any) {
          handleErrors(e, setErrors)
        }
      }}
    >
      {({values}) => (
        <Form id="brand" className='form'>
          <div className={'row'}>
            <div className={'col-6'}>
              <Field
                name="name"
                type="text"
                component={InputText}
                label="Brand name"
                description="Brand brand name"
                required={true}
              />
            </div>
            <div className={'col-6'}>
              <Field
                name="slug"
                type="text"
                component={InputText}
                label="Brand slug"
                description="Expected internal identifier"
                required={true}
              />
            </div>
          </div>
          <div className={'row'}>
            <div className={'col-6'}>
              <Field
                name="icon"
                type="text"
                component={InputText}
                label="Brand name"
                description="Font awesome icon name"
                required={true}
              />
            </div>
            <div className={'col-6'}>
              <Field
                name="color"
                type="text"
                component={InputText}
                className="text-uppercase"
                label="Color identifier"
                description="HTML color code"
                required={true}
              />
            </div>
          </div>

          {values.icon && (
            <div className="text-center">
              <i className={`${values.icon} fs-5x`} style={{color: values.color}}></i>
            </div>
          )}

          <Field
            component={FormActions}
            close={close}
          />
        </Form>
      )}
    </Formik>
  )
}

export {BrandForm}
